import React from "react";
import { MdGridOn, MdInfo } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import ReportsMenu from "./ReportsMenu";

export default function ArrowAndViewType() {
  return (
    <div className="d-flex">
      <ReportsMenu />
      {/* <div className="h-100 d-flex">
        <MdGridOn className="h-100 viewType" style={styles.alignMent} />
        <div className="textCenter">
          <div
            className="viewTypeText"
            style={{
              ...styles.alignMent,
              fontSize: 14,
              fontWeight: "bold",
              color: COLORS.TEXT_COLOR,
            }}
          >

          </div>
        </div>
        <MdInfo
          className="h-100 collaborators"
          style={{ ...styles.alignMent, fontSize: 16, marginLeft: 5 }}
        />
      </div> */}
    </div>
  );
}

const styles = {
  alignMent: {
    fontSize: 22,
    marginLeft: 10,
    cursor: "pointer",
  },
};
